import ApiClient from '../ApiClient';

class ExotelChannel extends ApiClient {
  constructor() {
    super('channels/exotel_channel', { accountScoped: true });
  }
}

export default new ExotelChannel();
